import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";
import QuestMinigame from "../QuestMinigame";

export default class MinigameButterflyCatch extends QuestMinigame {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._spawnTime = 0;
        this._spawnDelay = 0;

        this._player = null;
        this._npc = null;
        this._spawnAreas = null;
        this._butterflysInNet = [];
        this._allButterflys = [];

        this.coins = 1;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._spawnDelay = Math.max(metadata.spawnDelay);
        this._maxScore = this._spawnLimit = Math.max(metadata.spawnLimit);
        this._spawnAreas = metadata.spawnAreas;
        this.coins = metadata.coins;
    }

    /**
     * @param {GameScene} game
     */
    spawnButterfly(game) {
        const mapWidth = game.world.tilemap.width;
        const mapHeight = game.world.tilemap.height;

        const area = this._spawnAreas[this._allButterflys.length % this._spawnAreas.length];

        const position = game.world.findSafePosition(
            {
                x:mapWidth * area.x,
                y:mapHeight * area.y
            }, Math.min(mapWidth, mapHeight) * area.radius, 0, 20, [], 50);
            
        const butterfly = game.createEnemy(definitions.ENEMY_ID.BUTTERFLY, position, false, false);
        butterfly.target = game.player;
        butterfly.state = definitions.ENEMY_STATE.WANDER;

        butterfly.interactable = true;
        butterfly.interactionRadius = 0;
        butterfly.signals.grabbed.add(this.onButterflyCaught, this);

        this._allButterflys.push(butterfly);
    }

    /**
     * @param {GameScene} game
     */
    removeAllButterflys(game) {
        for (let i = 0, count = this._allButterflys.length; i < count; ++i) {
            const enemy = this._allButterflys[i];
            game.removeEnemy(enemy);
        }
    }

    /**
     * @param {Enemy} butterfly 
     */
    onButterflyCaught(butterfly) {
        if (butterfly.state !== definitions.ENEMY_STATE.WANDER)
            return;

        GameScene.active.removeEnemy(butterfly);
            
        this.score++;
        if(this.score >= this._maxScore){
            GameScene.active.completeMinigame(true);
        }
    }

    /**
     * @param {GameScene} game
     */
    _enableWorldButterfliesInteractive(game) {
        let currentButterfliesInWorld = game.findEnemies(definitions.ENEMY_ID.BUTTERFLY);
        for (let i = 0; i < currentButterfliesInWorld.length; ++i) {
            const butterfly = currentButterfliesInWorld[i];
            butterfly.interactable = true;
            butterfly.interactionRadius = 0;
            butterfly.signals.grabbed.add(this.onButterflyCaught, this);
        }
    }

    /**
     * @param {GameScene} game
     */
    _disableWorldButterfliesInteractive(game) {
        let currentButterfliesInWorld = game.findEnemies(definitions.ENEMY_ID.BUTTERFLY);
        for (let i = 0; i < currentButterfliesInWorld.length; ++i) {
            const butterfly = currentButterfliesInWorld[i];
            butterfly.interactable = false;
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        if(this.isRunning)
            return;

        super.onMinigameStart(game);

        this._player = game.player;

        this._npc = game.findNPC(this.owner);

        this._enableWorldButterfliesInteractive(game);
    }
    
    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        super.onMinigameUpdate();

        if (this.isRunning) {
            const butterflyCount = this._allButterflys.length;
            if (butterflyCount < this._spawnLimit) {
                if (this._spawnTime > this._spawnDelay) {
                    this._spawnTime = 0;
                    this.spawnButterfly(game);
                }
                this._spawnTime += window.dt;
            }
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        this.removeAllButterflys(game);

        this._disableWorldButterfliesInteractive(game);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameCancel(game) {
        super.onMinigameCancel(game);

        this.removeAllButterflys(game);
        
        this._disableWorldButterfliesInteractive(game);
    }
}